import * as React from "react";
import { Capability, CapabilityManager, ICapabilities } from "./";
import { Unsubscribable } from "rxjs";

interface IState
{
    capabilities?: ICapabilities;
}

interface IProps
{
    capability: Capability | undefined;
}

export default class WhenCapable extends React.Component<IProps, IState>
{
    private _capabilityManagerSubscription: Unsubscribable;

    constructor(props: IProps)
    {
        super(props);
        this.state = {};

        CapabilityManager.has(this.props.capability);
    }

    public render()
    {
        if (!this.props.capability)
        {
            return this.props.children;
        }

        if (this.state.capabilities && this.state.capabilities.has(this.props.capability))
        {
            return this.props.children;
        }

        return null;
    }

    public componentWillMount()
    {
        this._capabilityManagerSubscription = CapabilityManager.subscribe(capabilities => this.setState({ capabilities }));
    }

    public componentWillUnmount()
    {
        if (this._capabilityManagerSubscription)
        {
            this._capabilityManagerSubscription.unsubscribe();
        }
    }
}
